export default "__VITE_ASSET__Dzex7DKX__"